// TEMPORAL · revisión de la cadena del talento. Borrar tras la revisión del cliente.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CadenaBlock } from "@/components/cadena/CadenaBlock";

export default function CadenaReviewTmp() {
  const [cases, setCases] = useState(null);
  const [images, setImages] = useState([]);
  const [error, setError] = useState(false);
  const demo = new URLSearchParams(window.location.search).get("modo") === "demo";

  useEffect(() => {
    if (demo) {
      api.get("/admin/cadena-review/fixtures").then((r) => setCases(r.data)).catch(() => setError(true));
      return;
    }
    api.get("/admin/cadena-review/images").then(async (r) => {
      const out = [];
      for (const name of r.data) {
        const b = await api.get(`/admin/cadena-review/img/${name}`, { responseType: "blob" });
        out.push({ name, url: URL.createObjectURL(b.data) });
      }
      setImages(out);
    }).catch(() => setError(true));
  }, [demo]);

  if (error) return <p className="p-10 text-slate-500" data-testid="cadena-review-forbidden">No disponible.</p>;
  return (
    <main className="max-w-5xl mx-auto px-4 py-10 space-y-8" data-testid="cadena-review-page">
      <h1 className="font-display text-2xl font-bold">Revisión temporal · cadena del talento</h1>
      {demo && cases?.map((c) => (
        <section key={c.id} className="card" data-testid={`cadena-case-${c.id}`}>
          <p className="text-xs uppercase tracking-widest text-slate-400 mb-3">{c.titulo}</p>
          <CadenaBlock cadena={c.cadena} cambios={c.cambios} />
        </section>
      ))}
      {!demo && images.map((im) => (
        <figure key={im.name} className="space-y-2" data-testid={`cadena-review-img-${im.name}`}>
          <figcaption className="text-sm font-semibold text-slate-700">{im.name}</figcaption>
          <img src={im.url} alt={im.name} className="border rounded-lg max-w-full" />
        </figure>
      ))}
    </main>
  );
}
